import React, { useState } from 'react';
import { Tooltip } from 'src/components/atoms';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { useTheme } from 'styled-components';
import { StyledText, TooltipWrapper } from './FileUploadTooltip.styles';

interface Props {
  informationText: string;
  fileOptions: { type: string; options: string }[];
  className?: string;
  dataTestId?: string;
}

export const FileUploadTooltip = ({
  informationText,
  fileOptions,
  className,
  dataTestId = 'file-upload-type-information',
}: Props) => {
  const theme = useTheme();
  const [root, setRoot] = useState<HTMLElement | null>(null);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  return (
    <TooltipWrapper className={className}>
      <StyledText>{informationText}</StyledText>
      <StyledIcon
        className={'uil uil-info-circle'}
        onMouseOver={() => setTooltipVisible(true)}
        onMouseOut={() => setTooltipVisible(false)}
        ref={setRoot}
        color={
          tooltipVisible
            ? theme.atlas.semantic.color.action.primary.default
            : theme.atlas.semantic.color.type.default
        }
        size="15px"
        data-testid={dataTestId}
      />
      {tooltipVisible && root && (
        <Tooltip
          variant="down"
          root={root}
          data-testid="file-upload-tooltip"
          width="295px"
        >
          {fileOptions.map((option) => (
            <React.Fragment key={option.type}>
              <strong>{option.type}</strong> {option.options}
              <br />
            </React.Fragment>
          ))}
        </Tooltip>
      )}
    </TooltipWrapper>
  );
};
